import React, { useState } from 'react'

const Card = ({ title, content, lcolor, icon: Icon }) => {
  const [showModal, setShowModal] = useState(false);

  const handleComingSoonClick = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };
  return (
    <>
    <div className='group relative bg-gray-100 dark:bg-gray-700 hover:bg-white dark:hover:bg-gray-200 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-500 ease-out transform hover:-translate-y-2 hover:scale-[1.02] border border-gray-200 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500 overflow-hidden'>
      {/* Gradient Overlay */}
      <div className='absolute inset-0 bg-gradient-to-br from-green-50 to-transparent dark:from-green-900/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300'></div>

      {/* Animated Border */}
      <div className='absolute inset-0 rounded-xl border-2 border-transparent bg-gradient-to-r from-green-300 to-emerald-300 dark:from-green-600 dark:to-emerald-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10'></div>

      <div className='relative p-8'>
        {/* Icon and Title */}
        <div className='flex items-center gap-3 mb-4'>
            <div className='p-3 bg-green-50 dark:bg-green-900/30 rounded-lg group-hover:bg-gray-100 dark:group-hover:bg-gray-200 transition-colors duration-300'>
              <Icon size={24} className='text-green-600 dark:text-green-400 group-hover:text-gray-800 dark:group-hover:text-gray-700 group-hover:scale-110 transition-all duration-300' />
            </div>
          <h3 className='font-bold text-xl text-gray-800 dark:text-gray-100 group-hover:text-gray-900 dark:group-hover:text-gray-800 transition-colors duration-300'>
            {title}
          </h3>
        </div>

        {/* Content */}
        <div className='text-gray-600 dark:text-gray-200 group-hover:text-gray-800 dark:group-hover:text-gray-700 mb-6 leading-relaxed'>
          {content}
        </div>

        {/* Enhanced Button */}
        <button
          onClick={handleComingSoonClick}
          className={`relative w-full px-6 py-3 text-white font-semibold rounded-lg transition-all duration-300 transform group-hover:scale-[1.02] overflow-hidden ${lcolor} cursor-pointer`}
        >
          {/* Button shine effect */}
          <div className='absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000 ease-out'></div>

          <span className='relative flex items-center justify-center gap-2'>
            Coming Soon...
            <svg
              className='w-4 h-4 transition-transform duration-300 group-hover:rotate-12'
              fill='none'
              stroke='currentColor'
              viewBox='0 0 24 24'
            >
              <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z' />
            </svg>
          </span>
        </button>
      </div>

      {/* Floating particles effect */}
      <div className='absolute top-4 right-4 w-2 h-2 bg-green-400 dark:bg-green-500 rounded-full opacity-0 group-hover:opacity-100 animate-pulse transition-opacity duration-300'></div>
      <div className='absolute top-8 right-8 w-1 h-1 bg-emerald-400 dark:bg-emerald-500 rounded-full opacity-0 group-hover:opacity-100 animate-pulse transition-opacity duration-300 delay-150'></div>
    </div>

    {/* Contact Modal */}
    {showModal && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={closeModal}>
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl p-6 max-w-md w-full mx-4" onClick={(e) => e.stopPropagation()}>
          {/* Modal Header */}
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
              Contact Information
            </h3>
            <button 
              onClick={closeModal}
              className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          
          {/* Contact Details */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-blue-100 dark:bg-blue-900 rounded-lg">
                <svg className="w-5 h-5 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
              </div>
              <div>
                <p className="text-sm text-gray-600 dark:text-gray-400">Phone Number</p>
                <p className="text-lg font-semibold text-gray-900 dark:text-white">+91 9477879491</p>
              </div>
            </div>
            
            <div className="flex items-center gap-3">
              <div className="p-2 bg-green-100 dark:bg-green-900 rounded-lg">
                <svg className="w-5 h-5 text-green-600 dark:text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <div>
                <p className="text-sm text-gray-600 dark:text-gray-400">Email Address</p>
                <p className="text-lg font-semibold text-gray-900 dark:text-white">contact@rtobharat.com</p>
              </div>
            </div>
          </div>
          
          {/* Close Button */}
          <div className="mt-6 flex justify-end">
            <button 
              onClick={closeModal}
              className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors duration-200"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    )}
    </>
  )
}

export default Card
